











































































import { Vue, Prop, Component } from "vue-property-decorator";
import CustomTableItem from "@/components/form/CustomTableItem.vue";
import CustomTableCol from "@/components/form/CustomTableCol.vue";
import { Bill as IBill } from "@/api-v2/agent/models/bill";
import { LearningResource as ILearningResource } from "@/api-v2/agent/models/learning-resource";
import { courseApi } from "@/getinfo-api";

@Component({
  components: { CustomTableCol, CustomTableItem }
})
export default class AgentBillTableItem extends Vue {
  @Prop() bill!: IBill;
  isLoading: boolean = false;

  async getCourseLink(resource: ILearningResource) {
    try {
      this.isLoading = true;
      const responseV2 = await courseApi.Course.getCourse(resource.courseId);
      if (responseV2.data.id) {
        await this.$router.push({
          name: "course",
          params: { id: responseV2.data.id }
        });
      }
    } catch (e) {
      await this.$router.push({
        name: "courseView",
        params: { courseId: resource.courseId }
      });
    } finally {
      this.isLoading = false;
    }
  }
}
